export enum SnackBarType {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARNING ='warning',
  AVISO="aviso"
}
